/* =========================================================================
   OLIPHANT BREWING — Shopify Theme Behaviors
   Ported from _shared.js + js/global.js, adapted for Shopify:
   hamburger nav · horizontal scroll arrows · accordions · reveal-on-scroll ·
   AJAX add-to-cart + toast + cart-count · scroll-to-top FAB · age gate.
   ========================================================================= */
(function () {
  'use strict';

  /* ── Toast ─────────────────────────────────────────────────────────────── */
  var toastEl = null, toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '✓ ' + msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }
  window.OLIP_TOAST = showToast;

  /* ── Cart count sync ───────────────────────────────────────────────────── */
  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      })
      .catch(function () {});
  }

  /* ── AJAX add to cart ──────────────────────────────────────────────────── */
  function bindAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
        var name = btn.getAttribute('data-product-title') || 'item';
        if (!id) return;
        btn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            showToast('Added ' + qty + ' × ' + name);
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('oliphant:cart:added'));
          })
          .catch(function () { showToast('Could not add to cart'); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ── Hamburger / mobile menu ───────────────────────────────────────────── */
  function initHamburger() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var btn = header.querySelector('.nav-hamburger');
    var menu = header.querySelector('.nav-mobile-menu');
    if (!btn || !menu) return;
    function toggle() {
      var open = menu.classList.toggle('is-open');
      header.classList.toggle('nav-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
    btn.addEventListener('click', toggle);
    document.addEventListener('click', function (e) {
      if (menu.classList.contains('is-open') && !header.contains(e.target)) toggle();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) { toggle(); btn.focus(); }
    });
  }

  /* ── Horizontal scroll arrows ──────────────────────────────────────────── */
  function initScrollArrows() {
    document.querySelectorAll('.product-grid, .prod-scroll, .pscroll-track, .reviews-grid').forEach(function (track) {
      if (track.closest('.pscroll-wrap')) return;
      if (!track.children.length) return;
      if (track.getAttribute('data-no-arrows') !== null) return;

      var wrap = document.createElement('div');
      wrap.className = 'pscroll-wrap';
      track.parentNode.insertBefore(wrap, track);
      wrap.appendChild(track);

      var prev = document.createElement('button');
      prev.className = 'pscroll-btn pscroll-btn--prev';
      prev.setAttribute('aria-label', 'Scroll left');
      prev.innerHTML = '&#8592;';
      var next = document.createElement('button');
      next.className = 'pscroll-btn pscroll-btn--next';
      next.setAttribute('aria-label', 'Scroll right');
      next.innerHTML = '&#8594;';
      wrap.insertBefore(prev, track);
      wrap.appendChild(next);

      function amt() {
        var card = track.querySelector('.product-card, .pc, .review-card');
        return card ? card.offsetWidth * 3 + 20 : Math.max(track.clientWidth * 0.75, 300);
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -amt(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: amt(), behavior: 'smooth' }); });
      function update() {
        prev.classList.toggle('is-hidden', track.scrollLeft <= 4);
        next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
      }
      track.addEventListener('scroll', update, { passive: true });
      requestAnimationFrame(function () { requestAnimationFrame(update); });
    });
  }

  /* ── Accordions ────────────────────────────────────────────────────────── */
  function bindAccordions() {
    document.querySelectorAll('.accordion').forEach(function (acc) {
      acc.querySelectorAll('.accordion-trigger').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          var item = btn.closest('.accordion-item');
          if (item) item.classList.toggle('is-open');
        });
      });
    });
  }

  /* ── FAQ rows (.faq-toggle / .faq-row) ─────────────────────────────────── */
  function bindFaq() {
    document.querySelectorAll('.faq-toggle').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var row = btn.closest('.faq-row');
        if (row) row.classList.toggle('is-open');
      });
    });
  }

  /* ── Reveal on scroll ──────────────────────────────────────────────────── */
  function bindReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    (root || document).querySelectorAll('.reveal:not(.is-observed)').forEach(function (el) {
      el.classList.add('is-observed');
      io.observe(el);
    });
  }
  window.OLIP_BIND_REVEAL = bindReveal;

  /* ── PDP: variant pack-buttons + live price ────────────────────────────── */
  function initPdp() {
    document.querySelectorAll('[data-product-pdp]').forEach(function (pdp) {
      var priceEl = pdp.querySelector('[data-pdp-price]');
      pdp.querySelectorAll('.ph-packs input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          pdp.querySelectorAll('.pack-btn').forEach(function (l) { l.classList.remove('is-active'); });
          var label = input.closest('.pack-btn');
          if (label) label.classList.add('is-active');
          if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
        });
      });
    });
  }

  /* ── Tabs (.dt-tabs / [data-tab] + [data-tab-panel]) ───────────────────── */
  function initTabs() {
    document.querySelectorAll('.dt-tabs').forEach(function (tabs) {
      var scope = tabs.closest('section') || document;
      tabs.querySelectorAll('[data-tab]').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-tab');
          tabs.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          scope.querySelectorAll('[data-tab-panel]').forEach(function (p) {
            p.hidden = p.getAttribute('data-tab-panel') !== key;
          });
        });
      });
    });
  }

  /* ── Scroll-to-top FAB ─────────────────────────────────────────────────── */
  function initScrollTop() {
    var fab = document.createElement('button');
    fab.className = 'scroll-top';
    fab.setAttribute('aria-label', 'Back to top');
    fab.innerHTML = '&#8593;';
    fab.style.opacity = '0';
    fab.style.pointerEvents = 'none';
    fab.style.transition = 'opacity 200ms, transform 180ms, box-shadow 180ms';
    document.body.appendChild(fab);
    fab.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', function () {
      var show = window.scrollY > 600;
      fab.style.opacity = show ? '1' : '0';
      fab.style.pointerEvents = show ? 'auto' : 'none';
    }, { passive: true });
  }

  /* ── Age gate ──────────────────────────────────────────────────────────── */
  function initAgeGate() {
    var gate = document.getElementById('olip-age-gate');
    if (!gate) return;
    if (localStorage.getItem('olip_age_ok') === '1') { gate.remove(); return; }
    document.documentElement.style.overflow = 'hidden';
    gate.hidden = false;
    gate.querySelectorAll('[data-age-yes]').forEach(function (b) {
      b.addEventListener('click', function () {
        localStorage.setItem('olip_age_ok', '1');
        document.documentElement.style.overflow = '';
        gate.remove();
      });
    });
    gate.querySelectorAll('[data-age-no]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = 'https://www.google.com'; });
    });
  }

  /* ── Boot ──────────────────────────────────────────────────────────────── */
  function boot() {
    initHamburger();
    initScrollArrows();
    bindAccordions();
    bindFaq();
    bindReveal();
    bindAddToCart();
    initPdp();
    initTabs();
    initScrollTop();
    initAgeGate();
    refreshCartCount();
    document.addEventListener('shopify:section:load', function () {
      bindAccordions(); bindFaq(); bindReveal(); bindAddToCart(); initScrollArrows(); initPdp(); initTabs();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
